import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { Jobs } from "../../Interface/Jobs/jobs";
import { Constant } from "../../Shared/Models/constant";

@Injectable({
  providedIn: "root",
})
export class JobsService {
  Jobs: Observable<Jobs[]>;
  Constants = new Constant();
  private readonly url: string = this.Constants.localhost_url;

  private readonly Addnewjobs = this.url + "api/jobms";
  private readonly Deletejobs = this.url + "api/job/";
  private readonly NotYetAssigned = this.url + "api/jobms";
  private readonly Assigned = this.url + "api/jobms";
  private readonly pendingBills = this.url + "api/jobms";
  private readonly Tobeapproved = this.url + "api/jobms";
  private readonly Rejected = this.url + "api/jobms";
  private readonly Approved = this.url + "api/jobms";
  private readonly Completed = this.url + "api/jobms";
  private readonly Detail = this.url + "api/jobms/";
  private readonly bankDetails = this.url + "api/post-bank-details";
  private readonly deleteBankDetails = this.url + "api/delete-bank/";
  private readonly getLabourRemark = this.url + "api/get-labour-remarks/";
  private readonly deleteLabourRemark = this.url + "api/delete-labour-remarks/";
  private readonly VehicleDetail = this.url + "api/job/get-vehicle-detail";
  private readonly VehicleVariant = this.url + "api/job/vehicle-variants/";
  private readonly approvedstatusedit = this.url + "api/job/update-job/";
  private readonly updateJob = this.url + "api/job/update-job/";
  private readonly assignedemployee = this.url + "api/job-assign-ms";
  private readonly jobeditdetail = this.url + "api/jobms/";
  private readonly inspectionDetail = this.url + "api/update-inspection";
  private readonly approvedinpectionsave = this.url + "api/ms/post/tab-data";
  private readonly approvedinspectionget = this.url + "api/ms/get/tab-data";
  private readonly rejectJob = this.url + "api/job/";
  private readonly clientbranch = this.url + "api/clientbranch";
  private readonly updateRemark = this.url + "api/job/update-remark/";
  private readonly sentReportMail = this.url + "api/job/send-mail-report";
  private readonly updateJobImageUrl = this.url + "api/job/update-job-image/";
  private readonly contactPerson = this.url + "api/contactperson";
  private readonly inspectionDetailbyid = this.url + "api/get-job-by-id/";
  private readonly fileUpload = this.url + "api/file_upload";
  private readonly manualUpload = this.url + "api/manual-upload";
  private readonly surveyLink = this.url + "api/job-link-create/";
  private readonly assessmentLink = this.url + "api/assessment/";
  private readonly bodyAssessmentLink = this.url + "api/save-update-cabin-body-assessment/";
  private readonly bodyCabinTax = this.url + "api/save-update-cabin-body-tax/";
  private readonly getBodyAssessmentLink = this.url + "api/get-cabin-body-assessment-list/";
  private readonly getBodyTaxLink = this.url + "api/get-cabin-body-tax-setting/";
  private readonly getBodyAssessmentSummary = this.url + "api/get-cabin-body-assessment-summary/";
  private readonly taxDepSetting = this.url + "api/taxdepsetting/";
  private readonly isZeroDepSetting = this.url + "api/gettaxdep/";
  private readonly inspectionjobstatus = this.url + "api/inspection-jobstatus/";
  private readonly summaryLink = this.url + "api/getassessmentsummary/";
  private readonly summaryDataSave = this.url + "api/assesment-inputupdate";
  private readonly storeAttachmentMaster = this.url + "api/storeattachmentmaster";
  private readonly deleteMasterAttachment = this.url + "api/deletemasterattachment?";
  private readonly saveDynamicSectionMaster = this.url + "api/savedynamicsectionmaster";
  private readonly deleteDynamicSectionMaster = this.url + "api/deletedynamicsectionmaster?";
  private readonly vehicleApiData = this.url + "api/getvehicledata";
  private readonly getJobDetailsList = this.url + "api/get_job_details_list";
  private readonly getStructureList = this.url + "api/ms/get-estimate-structure";
  private readonly storeStructureData = this.url + "api/ms/import-estimate-structure";
  private readonly estimateStructure = this.url + "api/ms/estimate-structure";
  private readonly base64URL = this.url + "api/ms/get/base-encode";
  private readonly getStructureInfo = this.url + "api/ms/estimate-structure-details/";
  private readonly feeBillRefreshURL = this.url + "api/fee-bill-calculation/";
  private readonly reclaim = this.url + "api/checkVehicle";

  private readonly uploadFileURL = this.url + "api/v2/extract-tables"; // new API
 
  // private readonly uploadFileURL = this.url + "api/extract-tables"; //Old Api
 
  private readonly getUpdateForData = this.url + "api/job-status/";
  private readonly getExtractedDataURL = this.url + "api/ai-module/extraction-jobs";
  private readonly aiModuleWorkshopExtractURL = this.url + "api/ai-module/workshop/extract";
  private readonly aiModuleJobStatusURL = this.url + "api/ai-module/documents/jobs/";
  private readonly billCheckDataURL = this.url + "api/ai-module/extraction-jobs/bill-check-data";
  private readonly uploadDocDataURL = this.url + "api/ai-module/extraction-jobs/upload-doc-data";

  //All Claims section only
  // private readonly AllClaimsAPI = 'https://moval.techkrate.in/backend/api/jobms';
  private readonly AllClaimsAPI = this.url + "api/jobms";

  //private readonly getUpdateForData = this.url.replace('backend/','') +"api_new/tasks/";
  private readonly AddLocalWorkshop = this.url + "api/add-local-workshop";
  private readonly EditLocalWorkshop = this.url + "api/edit-local-workshop/";
  private readonly AddPrivateTemplate = this.url + "api/ms/add-pod-template";
  private readonly replaceTagURL = this.url + "api/ms/replace-tags-data/";
  private readonly GetPrivateTemplate = this.url + "api/ms/pod-template-list/"
  private readonly saveUpdateLabourRemark = this.url + "api/save-update-labour-remarks"
  private readonly saveEstimateDetails = this.url + "api/save-update-estimates-details/";
  private readonly getEstimateDetails = this.url + "api/get-estimated-detail/";
  private readonly getEstimateDetailsUrl = this.url + "api/delete-estimates-details";
  private readonly fileExcellUpload = this.url + "api/ms/import";
  private readonly reportSettingsApi = this.url + "api/ms/report-settings";
  private readonly depreciations = this.url + 'api/depreciations';
  private readonly paymentDetails = this.url + 'api/feebill/payment-details';
  private readonly deductionDetails = this.url + 'api/feebill/deduction-details';
  private readonly salvageAmountByBasis = this.url + "api/salvage-amount-by-basis/";

  constructor(private readonly httpClient: HttpClient) { }

  contactpersonlist(id: string): Observable<any> {
    return this.httpClient.get(
      `${this.contactPerson + "?all=&branch_id="}` + id
    );
  }

  getBase64URL(urlData): Observable<any> {
    let file = {
      url: urlData,
    };
    return this.httpClient.post(`${this.base64URL}`, file);
  }

  vehicleData(
    vehicle_make,
    vehicle_variant = "",
    vehicle_model = ""
  ): Observable<any> {
    return this.httpClient.get(
      `${this.vehicleApiData}?vehicle_make=${vehicle_make}&vehicle_variant=${vehicle_variant}&vehicle_model=${vehicle_model}`
    );
  }

  getJobDetails() {
    return this.httpClient.get(`${this.getJobDetailsList}`);
  }

  structureList(): Observable<any> {
    return this.httpClient.get(`${this.getStructureList}`);
  }

  Addjobs(Addjobsdata: Object, id = null): Observable<any> {
    if (id) return this.jobEditDetail(Addjobsdata, id);
    else return this.httpClient.post(`${this.Addnewjobs}`, Addjobsdata);
  }

  storeStructure(formValue: Object): Observable<any> {
    return this.httpClient.post(`${this.storeStructureData}`, formValue);
  }

  addVehicleManufacturer(formValue: Object): Observable<any> {
    return this.httpClient.post(`${this.estimateStructure}`, formValue);
  }

  deleteVehicleManufacturer(id): Observable<any> {
    return this.httpClient.delete(`${this.estimateStructure}/${id}`);
  }

  saveEstimateDetail(formValue: Object, id): Observable<any> {
    return this.httpClient.post(`${this.saveEstimateDetails}${id}`, formValue);
  }

  getEstimateDetail(id): Observable<any> {
    return this.httpClient.get(`${this.getEstimateDetails}` + id);
  }

  getStructureData(id): Observable<any> {
    return this.httpClient.get(`${this.getStructureInfo}` + id);
  }

  storeAttachment(Addattachment: Object): Observable<any> {
    return this.httpClient.post(
      `${this.storeAttachmentMaster}`,
      Addattachment
    );
  }

  deleteAttachment(id): Observable<any> {
    return this.httpClient.delete(
      `${this.deleteMasterAttachment}key=` + id
    );
  }

  JobsNotYetAssigned(
    PageNo: string,
    SearchTxt: string,
    FromDate: string,
    ToDate: string,
    isOffline: boolean
  ): Observable<any> {

    var offline = "no";
    if (isOffline) {
      offline = "yes";
    }

    return this.httpClient.get(
      `${this.NotYetAssigned +
      "?status=created,pending&is_offline=" +
      offline +
      "&q=" +
      SearchTxt +
      "&from_date=" +
      FromDate +
      "&to_date=" +
      ToDate +
      "&page=" +
      PageNo +
      "&search_type=registration_no"
      }`
    );
  }

  JobsAssigned(
    PageNo: string,
    SearchTxt: string,
    search_type: string,
    FromDate: string,
    ToDate: string,
    isOffline: boolean,
    surveyStatus?: string
  ): Observable<any> {

    var offline = "no";
    if (isOffline) {
      offline = "yes";
    }

    let status = "created,pending";
    if (surveyStatus === "created") {
      status = "created";
    } else if (surveyStatus === "pending") {
      status = "pending";
    }

    return this.httpClient.get(
      `${this.Assigned +
      "?status=" + status +
      "&is_offline=" +
      offline +
      "&q=" +
      SearchTxt +
      "&from_date=" +
      FromDate +
      "&to_date=" +
      ToDate +
      "&page=" +
      PageNo +
      "&search_type=" +
      search_type
      }`
    );
  }

  PendingBillsList(
    PageNo: string,
    SearchTxt: string,
    search_type: string,
    FromDate: string,
    ToDate: string,
    isOffline: boolean
  ): Observable<any> {

    var offline = "no";
    if (isOffline) {
      offline = "yes";
    }

    return this.httpClient.get(
      `${this.pendingBills +
      "?status=billing&is_offline=" +
      offline +
      "&q=" +
      SearchTxt +
      "&from_date=" +
      FromDate +
      "&to_date=" +
      ToDate +
      "&page=" +
      PageNo +
      "&search_type=" +
      search_type
      }`
    );
  }

  JobsTobeapproved(
    PageNo: string,
    SearchTxt: string,
    search_type: string,
    FromDate: string,
    ToDate: string,
    isOffline: boolean
  ): Observable<any> {

    var offline = "no";
    if (isOffline) {
      offline = "yes";
    }

    return this.httpClient.get(
      `${this.Tobeapproved +
      "?status=submitted&is_offline=" +
      offline +
      "&q=" +
      SearchTxt +
      "&from_date=" +
      FromDate +
      "&to_date=" +
      ToDate +
      "&page=" +
      PageNo +
      "&search_type=" +
      search_type
      }`
    );
  }

  JobsRejected(
    PageNo: string,
    SearchTxt: string,
    search_type: string,
    FromDate: string,
    ToDate: string,
    isOffline: boolean
  ): Observable<any> {

    var offline = "no";
    if (isOffline) {
      offline = "yes";
    }

    return this.httpClient.get(
      `${this.Rejected +
      "?status=rejected&is_offline=" +
      offline +
      "&q=" +
      SearchTxt +
      "&from_date=" +
      FromDate +
      "&to_date=" +
      ToDate +
      "&page=" +
      PageNo +
      "&search_type=" +
      search_type
      }`
    );
  }

  JobsApproved(
    PageNo: string,
    SearchTxt: string,
    search_type: string,
    FromDate: string,
    ToDate: string,
    isOffline: boolean
  ): Observable<any> {
    var offline = "no";
    if (isOffline) {
      offline = "yes";
    }

    return this.httpClient.get(
      `${this.Approved +
      "?status=approved&is_offline=" +
      offline +
      "&q=" +
      SearchTxt +
      "&from_date=" +
      FromDate +
      "&to_date=" +
      ToDate +
      "&page=" +
      PageNo +
      "&search_type=" +
      search_type
      }`
    );
  }

  JobsCompleted(
    PageNo: string,
    SearchTxt: string,
    search_type: string,
    FromDate: string,
    ToDate: string,
    isOffline: boolean,
    billing = false
  ): Observable<any> {
    var offline = "no";
    if (isOffline) {
      offline = "yes";
    }
    var status = billing ? "billing_finalized,finalized" : "finalized";
    return this.httpClient.get(
      `${this.Completed +
      "?status=" + status + "&is_offline=" +
      offline +
      "&q=" +
      SearchTxt +
      "&from_date=" +
      FromDate +
      "&to_date=" +
      ToDate +
      "&page=" +
      PageNo +
      "&search_type=" +
      search_type
      }`
    );
  }


  getAllClaims(
    PageNo: string,
    SearchTxt: string,
    search_type: string,
    FromDate: string,
    ToDate: string,
    isOffline: boolean,
    status?: string,
    vehicleType?: string,
    tatStatus?: string,
    adminBranchId?: string | number,
    clientId?: string | number,
    clientBranchId?: string | number
  ): Observable<any> {

    // Use provided status, or default to all statuses, or use SearchTxt if searching by status
    let finalStatus = status || 'created,pending,submitted,approved,finalized';
    let query = SearchTxt || '';
    let type = search_type || 'registration_no';

    // If search_type is 'status' and SearchTxt is provided, use SearchTxt as status
    // (unless a status parameter was explicitly provided)
    if (!status && search_type === 'status' && SearchTxt) {
      finalStatus = SearchTxt.trim().toLowerCase();
      // Clear query and type so backend strictly uses status param
      query = '';
      type = '';
    }

    const params: { [key: string]: string } = {
      status: finalStatus,
      is_offline: isOffline ? 'yes' : 'no',
      q: query,
      from_date: FromDate || '',
      to_date: ToDate || '',
      page: PageNo,
      search_type: type
    };
    if (vehicleType) {
      params['vehicle_type'] = vehicleType;
    }
    if (tatStatus) {
      params['tat_status'] = tatStatus;
    }
    if (adminBranchId !== undefined && adminBranchId !== null && adminBranchId !== '') {
      params['admin_branch_id'] = String(adminBranchId);
    }
    if (clientId !== undefined && clientId !== null && clientId !== '') {
      params['client_id'] = String(clientId);
    }
    if (clientBranchId !== undefined && clientBranchId !== null && clientBranchId !== '') {
      params['client_branch_id'] = String(clientBranchId);
    }

    return this.httpClient.get(this.AllClaimsAPI, { params });
  }

  checkVehicle(regNo: string) {
    return this.httpClient.post<any>(
      `${this.reclaim}`,
      { vehicle_reg_no: regNo }
    );
  }

  // api.service.ts

  // checkVehicle(regNo: string) {
  //   return this.httpClient.post<any>(
  //     'http://127.0.0.1:8000/api/check-vehicle',
  //     { vehicle_reg_no: regNo }
  //   );
  // }


  JobDelete(id: string): Observable<any> {
    return this.httpClient.delete(`${this.Deletejobs}` + id);
  }

  MasterDelete(id: string): Observable<any> {
    return this.httpClient.delete(
      `${this.deleteDynamicSectionMaster}id=` + id
    );
  }

  JobDetail(id: string): Observable<any> {
    return this.httpClient.get(`${this.Detail}` + id);
  }

  SaveMasterDetail(formData): Observable<any> {
    return this.httpClient.post(
      `${this.saveDynamicSectionMaster}`,
      formData
    );
  }

  InspectionDetailbyid(id): Observable<any> {
    return this.httpClient.get(`${this.inspectionDetailbyid}` + id);
  }

  AssesmentInspectionDetailbyid(formName, id): Observable<any> {
    return this.httpClient.get(
      `${this.approvedinspectionget}?type=${formName}&inspection_id=` +
      id
    );
  }

  UpdateJobRemark(id: string, obj: object): Observable<any> {
    return this.httpClient.put(`${this.updateRemark}` + id, obj);
  }

  CreateSurveyLink(id: string): Observable<any> {
    return this.httpClient.get(`${this.surveyLink}` + id);
  }

  ApprovedStatusEdit(id: string): Observable<any> {
    return this.httpClient.put(`${this.rejectJob}` + id + "/approved", {}
    );
  }

  CompletedStatusEdit(id: string): Observable<any> {
    return this.httpClient.get(`${this.rejectJob + "finalize-report/"}` + id);
  }

  SummaryDataSave(formData): Observable<any> {
    return this.httpClient.post(`${this.summaryDataSave}`, formData);
  }

  SentMailReport(employeeedit: object, jobid: string): Observable<any> {
    return this.httpClient.post(`${this.sentReportMail}`, employeeedit);
  }

  AssignedEmployeelist(
    employeeedit: object,
    jobid: string,
    AssignName
  ): Observable<any> {
    return this.httpClient.post(`${this.assignedemployee}`, employeeedit);
  }

  jobEditDetail(jobdata: Object, id: string): Observable<any> {
    jobdata['admin_branch_id'] = "" + jobdata['admin_branch_id'];
    return this.httpClient.put(`${this.jobeditdetail}` + id, jobdata);
  }

  InspectionDetail(jobdata: Object): Observable<any> {
    return this.httpClient.post(`${this.inspectionDetail}`, jobdata);
  }

  ApprovedFormSubmit(jobdata: Object): Observable<any> {
    return this.httpClient.post(`${this.approvedinpectionsave}`, jobdata);
  }

  jobUpdateDetail(jobdata: Object, id: string): Observable<any> {
    return this.httpClient.put(`${this.updateJob}` + id, jobdata);
  }

  rejectJobService(id: string, remark: string): Observable<any> {
    return this.httpClient.put(
      `${this.rejectJob}` + id + "/rejected",
      { remark: remark }
    );
  }

  getVehicleDetails(obj: object): Observable<any> {
    return this.httpClient.post(`${this.VehicleDetail}`, obj);
  }

  getVehicleVariant(obj: object, id: string): Observable<any> {
    return this.httpClient.post(`${this.VehicleVariant}` + id, obj);
  }

  branchlist(id: string): Observable<any> {
    return this.httpClient.get(`${this.clientbranch + "?all=&client_id="}` + id);
  }

  updateJobImage(
    file: File,
    jobid: string,
    imageid: string,
    type: string
  ): Observable<any> {
    let formParams = new FormData();
    formParams.append("file", file);
    formParams.append("type", type);
    formParams.append("image_id", imageid);
    return this.httpClient.post(
      `${this.updateJobImageUrl}` + jobid,
      formParams
    );
  }

  uploadJobDoc(Base64Image): Observable<any> {
    return this.httpClient.post(`${this.fileUpload}`, Base64Image);
  }

  UploadJob(fileList): Observable<any> {
    return this.httpClient.post(`${this.manualUpload}`, fileList);
  }

  AssessmentDetail(id): Observable<any> {
    return this.httpClient.get(`${this.assessmentLink}` + id);
  }

  SummaryLink(id): Observable<any> {
    return this.httpClient.get(`${this.summaryLink}` + id);
  }

  TaxDepSetting(id): Observable<any> {
    return this.httpClient.get(`${this.taxDepSetting}` + id);
  }

  isZeroDepSettings(id): Observable<any> {
    return this.httpClient.get(`${this.isZeroDepSetting}` + id + "?IsZeroDep=1");
  }

  SaveTaxDepSetting(FileData, id): Observable<any> {
    return this.httpClient.post(`${this.taxDepSetting}` + id, FileData);
  }

  InspectionApproved(id): Observable<any> {
    return this.httpClient.get(`${this.inspectionjobstatus}` + id);
  }

  AssessmentSubmit(FileData, id): Observable<any> {
    return this.httpClient.post(`${this.assessmentLink}` + id, FileData);
  }

  AssessmentRowsUpdate(id, rows: any[]): Observable<any> {
    return this.httpClient.put(`${this.assessmentLink}${id}/rows`, rows);
  }

  bodyCabinAssessmentSubmit(FileData, id): Observable<any> {
    return this.httpClient.post(`${this.bodyAssessmentLink}` + id, FileData);
  }

  bodyCabinTaxSubmit(FileData, id): Observable<any> {
    return this.httpClient.post(`${this.bodyCabinTax}` + id, FileData);
  }

  getBodyCabinAsseementApi(id): Observable<any> {

    return this.httpClient.get(`${this.getBodyAssessmentLink}` + id);
  }

  getBodyCabinAssementSummary(id): Observable<any> {
    return this.httpClient.get(`${this.getBodyAssessmentSummary}` + id);
  }

  getBodyCabinAssementTaxLink(id): Observable<any> {
    return this.httpClient.get(`${this.getBodyTaxLink}` + id);
  }

  saveBodyCabinAssementTaxLink(FileData, id): Observable<any> {
    return this.httpClient.post(`${this.bodyCabinTax}` + id, FileData);
  }

  uploadPDf(FileData): Observable<any> {

    return this.httpClient.post(`${this.uploadFileURL}`, FileData);
  }

  getUpdateUsingId(taskId): Observable<any> {
    return this.httpClient.get(`${this.getUpdateForData}${taskId}`);
  }

  getExtractedData(inspectionId, documentType, source?: string): Observable<any> {
    const sourceParam = source ? `&source=${source}` : "";
    return this.httpClient.get(
        `${this.getExtractedDataURL}?inspection_id=${inspectionId}&document_type=${documentType}${sourceParam}`,
    );
  }

  uploadWorkshopDocument(formData: FormData): Observable<any> {
    return this.httpClient.post(`${this.aiModuleWorkshopExtractURL}`, formData);
  }

  getAiModuleJobStatus(jobId: string): Observable<any> {
    return this.httpClient.get(`${this.aiModuleJobStatusURL}${jobId}`);
  }

  deleteExtractedData(inspectionId, documentType): Observable<any> {
    return this.httpClient.delete(this.getExtractedDataURL, {
        body: { inspection_id: inspectionId, document_type: documentType },
    });
  }

  softDeleteExtraction(uniqueId: string | string[]): Observable<any> {
    return this.httpClient.delete(this.getExtractedDataURL, {
        body: { unique_id: uniqueId },
    });
  }

  saveBillCheckData(payload: { inspection_id: any; document_type: string; bill_check_data?: any; estimate_structure_id?: any; upload_invoice_only?: boolean }): Observable<any> {
    return this.httpClient.post(this.billCheckDataURL, payload);
  }

  uploadDocData(payload: {
    inspection_id: any;
    updated_result: { dl_data: any; rc_data: any; policy_data: any; claim_data: any };
    extracted_data_submitted?: boolean;
  }): Observable<any> {
    return this.httpClient.post(this.uploadDocDataURL, payload);
  }

  feeBillRefresh(id): Observable<any> {
    return this.httpClient.get(`${this.feeBillRefreshURL}${id}`);
  }

  getLocalWorkshop(id): Observable<any> {
    return this.httpClient.get(`${this.EditLocalWorkshop}${id}`);
  }

  getTemplateDetails(id): Observable<any> {
    return this.httpClient.get(`${this.GetPrivateTemplate}${id}`);
  }

  storeLocalWorkshop(FileData): Observable<any> {
    return this.httpClient.post(`${this.AddLocalWorkshop}`, FileData);
  }

  storeTemplate(FileData): Observable<any> {
    return this.httpClient.post(`${this.AddPrivateTemplate}`, FileData);
  }

  replaceTagData(id): Observable<any> {
    return this.httpClient.get(`${this.replaceTagURL}${id}`);
  }

  saveBankDetails(FileData): Observable<any> {
    return this.httpClient.post(`${this.bankDetails}`, FileData);
  }

  removeBankDetails(index): Observable<any> {
    return this.httpClient.delete(`${this.deleteBankDetails}${index}`);
  }

  getLabourRemarkData(admin_id, type): Observable<any> {
    return this.httpClient.get(`${this.getLabourRemark}${admin_id}/${type}`);
  }

  saveUpdateLabourRemarkData(FileData, id) {
    let url = id ? this.saveUpdateLabourRemark + '/' + id : this.saveUpdateLabourRemark;
    return this.httpClient.post(`${url}`, FileData);
  }

  deleteLabourRemarkApi(admin_id, id) {
    return this.httpClient.delete(`${this.deleteLabourRemark}${admin_id}/${id}`);
  }

  deleteEstimateDetails(id: string): Observable<any> {
    return this.httpClient.delete(`${this.getEstimateDetailsUrl}/${id}`);
  }

  uploadFile(formData: FormData): Observable<any> {
    return this.httpClient.post(`${this.fileExcellUpload}`, formData);
  }

  submitReportSettings(reportSettings: any): Observable<any> {
    return this.httpClient.post<any>(`${this.reportSettingsApi}`, reportSettings);
  }

  getReportSettings(id) {
    return this.httpClient.get<any>(`${this.reportSettingsApi}/${id}`);
  }

  getDepreciations(inspectionId, type) {
    return this.httpClient.get<any>(`${this.depreciations}/${inspectionId}/${type}`);
  }

  // Vehicle Types API endpoints
  private readonly vehicleTypesUrl = this.url + "api/ms/spot-survey/vehicle-types";
  private readonly descriptionsUrl = this.url + "api/ms/spot-survey/descriptions";

  getVehicleTypes(): Observable<any> {
    return this.httpClient.get(`${this.vehicleTypesUrl}`);
  }

  createVehicleType(vehicleType: any): Observable<any> {
    return this.httpClient.post(`${this.vehicleTypesUrl}`, vehicleType);
  }

  updateVehicleType(id: number, vehicleType: any): Observable<any> {
    return this.httpClient.put(`${this.vehicleTypesUrl}/${id}`, vehicleType);
  }

  deleteVehicleType(id: number): Observable<any> {
    return this.httpClient.delete(`${this.vehicleTypesUrl}/${id}`);
  }

  getDescriptions(vehicleTypeId: string): Observable<any> {
    return this.httpClient.get(`${this.descriptionsUrl}/${vehicleTypeId}`);
  }

  saveDescriptions(descriptionsData: any): Observable<any> {
    return this.httpClient.post(`${this.descriptionsUrl}`, descriptionsData);
  }

  private readonly tatByVehicleTypeUrl = this.url + "api/ms/tat-by-vehicle-type";

  getTatByVehicleType(adminBranchId?: string | number): Observable<any> {
    const params: { [key: string]: string } = {};
    if (adminBranchId !== undefined && adminBranchId !== null && adminBranchId !== "") {
      params.admin_branch_id = String(adminBranchId);
    }
    return this.httpClient.get(`${this.tatByVehicleTypeUrl}`, { params });
  }

  saveTatByVehicleType(data: { id?: number; vehicle_type: string; days_count: number; admin_branch_id: string | number }): Observable<any> {
    return this.httpClient.post(`${this.tatByVehicleTypeUrl}`, data);
  }

  deleteTatByVehicleType(id: number, adminBranchId: string | number): Observable<any> {
    return this.httpClient.delete(`${this.tatByVehicleTypeUrl}/${id}`, { params: { admin_branch_id: String(adminBranchId) } });
  }

  private readonly reminderMasterUrl = this.url + "api/ms/reminder-master";

  getReminderMaster(adminBranchId?: string | number): Observable<any> {
    const params: { [key: string]: string } = {};
    if (adminBranchId !== undefined && adminBranchId !== null && adminBranchId !== "") {
      params.admin_branch_id = String(adminBranchId);
    }
    return this.httpClient.get(`${this.reminderMasterUrl}`, { params });
  }

  saveReminderMaster(data: {
    id?: number;
    admin_branch_id: string | number;
    reminder_name: string;
    applies_to: string[];
    send_on_type: string;
    send_on_value: number;
    send_on?: string;
    sms: boolean;
    email: boolean;
    whatsapp: boolean;
    letter_format: string;
    status: string;
  }): Observable<any> {
    return this.httpClient.post(`${this.reminderMasterUrl}`, data);
  }

  deleteReminderMaster(id: number, adminBranchId: string | number): Observable<any> {
    return this.httpClient.delete(`${this.reminderMasterUrl}/${id}`, { params: { admin_branch_id: String(adminBranchId) } });
  }

  private readonly reminderTemplateMasterUrl = this.url + "api/ms/reminder-template-master";

  getReminderTemplates(filters: { reminderId?: number | string; transactionType?: string; adminBranchId?: string | number }): Observable<any> {
    const params: { [key: string]: string } = {};
    if (filters.reminderId !== undefined && filters.reminderId !== null && filters.reminderId !== "") {
      params["reminder_id"] = String(filters.reminderId);
    }
    if (filters.transactionType) {
      params["transaction_type"] = filters.transactionType;
    }
    if (filters.adminBranchId !== undefined && filters.adminBranchId !== null && filters.adminBranchId !== "") {
      params["admin_branch_id"] = String(filters.adminBranchId);
    }
    return this.httpClient.get(`${this.reminderTemplateMasterUrl}`, { params });
  }

  getReminderTemplateDetail(id: number): Observable<any> {
    return this.httpClient.get(`${this.reminderTemplateMasterUrl}/detail/${id}`);
  }

  createReminderTemplate(data: {
    reminder_id: number;
    transaction_type: string;
    template_value: string;
    admin_branch_id: string | number;
  }): Observable<any> {
    return this.httpClient.post(`${this.reminderTemplateMasterUrl}`, data);
  }

  updateReminderTemplate(
    id: number,
    data: { reminder_id?: number; transaction_type?: string; template_value?: string; admin_branch_id?: string | number }
  ): Observable<any> {
    return this.httpClient.put(`${this.reminderTemplateMasterUrl}/${id}`, data);
  }

  deleteReminderTemplate(id: number, adminBranchId?: string | number): Observable<any> {
    const params: { [key: string]: string } = {};
    if (adminBranchId !== undefined && adminBranchId !== null && adminBranchId !== "") {
      params["admin_branch_id"] = String(adminBranchId);
    }
    return this.httpClient.delete(`${this.reminderTemplateMasterUrl}/${id}`, { params });
  }

  private readonly manualSendEmailUrl = this.url + "api/ms/manual-send-email";

  sendManualEmail(data: {
    to: string[];
    cc?: string[];
    subject: string;
    body: string;
    reminderType: string;
    claim_no: string;
  }): Observable<any> {
    return this.httpClient.post(`${this.manualSendEmailUrl}`, data);
  }

  private readonly emailLogsUrl = this.url + "api/ms/email-logs";

  getEmailLogs(filters: {
    claimNo?: string;
    reminderType?: string;
    status?: string;
    moduleName?: string;
    recipientEmail?: string;
    subject?: string;
    fromDate?: string;
    toDate?: string;
    perPage?: number | string;
    page?: number | string;
  }): Observable<any> {
    const params: { [key: string]: string } = {};
    if (filters.claimNo) {
      params["claim_no"] = filters.claimNo;
    }
    if (filters.reminderType) {
      params["reminder_type"] = filters.reminderType;
    }
    if (filters.status) {
      params["status"] = filters.status;
    }
    if (filters.moduleName) {
      params["module_name"] = filters.moduleName;
    }
    if (filters.recipientEmail) {
      params["recipient_email"] = filters.recipientEmail;
    }
    if (filters.subject) {
      params["subject"] = filters.subject;
    }
    if (filters.fromDate) {
      params["from_date"] = filters.fromDate;
    }
    if (filters.toDate) {
      params["to_date"] = filters.toDate;
    }
    if (filters.perPage) {
      params["per_page"] = String(filters.perPage);
    }
    if (filters.page) {
      params["page"] = String(filters.page);
    }
    return this.httpClient.get(`${this.emailLogsUrl}`, { params });
  }

  getEmailLogDetail(id: number | string): Observable<any> {
    return this.httpClient.get(`${this.emailLogsUrl}/${id}`);
  }

  // Fee bill inspection report search API
  searchInspectionReports(params: { [key: string]: any }): Observable<any> {
    const query = Object.keys(params)
      .filter((key) => params[key] !== undefined && params[key] !== null && params[key] !== "")
      .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
      .join("&");
    return this.httpClient.get<any>(`${this.url}api/feebill/inspection-reports?${query}`);
  }

  // Payment Details API
  submitPaymentDetails(paymentData: any): Observable<any> {
    return this.httpClient.post(`${this.paymentDetails}`, paymentData);
  }

  // Deduction Details API
  submitDeductionDetails(deductionData: any): Observable<any> {
    return this.httpClient.post(`${this.deductionDetails}`, deductionData);
  }

  // Delete Fee Bill Report API
  deleteFeeBillReport(data: any): Observable<any> {
    return this.httpClient.post(`${this.url}api/feebill/deletefeebillreport`, data);
  }

  getSalvageAmountByBasis(id: string, basis: string, percent: number): Observable<any> {
    return this.httpClient.get(`${this.salvageAmountByBasis}${id}?basis=${basis}&percent=${percent}`);
  }
}
